import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';
import lodash from 'lodash';
var bootstrapdatetimepicker = require('bootstrap-datetimepicker-npm');

var _ = lodash;
window._ = _;
window.lodash = lodash;

window.Vue = Vue;


window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        Vue.use(VueGoogleMaps, {
            load: {
                key: window.env.GOOGLE_MAP_KEY,
                libraries: "places" // necessary for places input
            }
        });

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.dispatchEvent(new CustomEvent('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.getAttribute('data-src');
    })
    .value();
